import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { AddDeliveryPartner } from "../../../features/dashboard/newBuilderSlice";
import toast from "react-hot-toast";
import { showLoader, hideLoader } from "../../../features/ui/uiSlice";
import { fetchDeliveryPartner } from "../../../features/dashboard/newBuilderSlice";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const AddDeliveryPersonModal = ({ show, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    phone: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "email") {
      if (value.trim() && !/\S+@\S+\.\S+/.test(value)) {
        setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
      } else {
        setErrors((prev) => ({ ...prev, email: "" }));
      }
    } else if (name === "password") {
      const strongPasswordPattern =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

      if (value.trim() && !strongPasswordPattern.test(value)) {
        setErrors((prev) => ({
          ...prev,
          password:
            "Password must include upper, lower, number & symbol (8+ chars)",
        }));
      } else {
        setErrors((prev) => ({ ...prev, password: "" }));
      }
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.username.trim()) newErrors.username = "Username is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else {
      const strongPasswordPattern =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

      if (!strongPasswordPattern.test(formData.password)) {
        newErrors.password =
          "Password must include upper, lower, number & symbol (8+ chars)";
      }
    }
    if (
      !formData.phone ||
      formData.phone === "+251" ||
      formData.phone.length <= 4
    ) {
      newErrors.phone = "Phone number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;

    // 🔹 Trim all string fields before sending
    const trimmedData = {
      name: formData.name.trim(),
      username: formData.username.trim(),
      email: formData.email.trim(),
      password: formData.password.trim(),
      phone: formData.phone.trim(),
    };

    dispatch(showLoader());

    dispatch(AddDeliveryPartner(trimmedData))
      .unwrap()
      .then((res) => {
        console.log("API Response:", res);

        if (
          res?.partner_id ||
          res?.message?.toLowerCase()?.includes("success")
        ) {
          toast.success("Delivery partner added successfully!");

          // Reset form
          setFormData({
            name: "",
            username: "",
            email: "",
            password: "",
            phone: "",
          });

          // Close modal
          onClose();
          dispatch(fetchDeliveryPartner({ page: 1, limit: 10 }));
        } else {
          toast.error(res?.message || "Failed to add delivery partner");
        }
      })
      .catch((err) => {
        console.error("Error adding delivery person:", err);
        toast.error(
          err?.message || "Something went wrong while adding partner!",
        );
      })
      .finally(() => {
        dispatch(hideLoader());
      });
  };

  if (!show) return null;

  return (
    <div
      className="modal  show  overflow-y-auto"
      style={{ display: "block", marginTop: "90px", height: "600px" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-light">
          <div className="modal-header">
            <h5 className="modal-title text-light">Add Delivery Person</h5>
            <button
              type="button"
              className="btn-close btn-close-light"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="mb-2 col-12 col-md-6">
                <label className="form-label text-light">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={`form-control  ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter name"
                  style={{
                    borderColor: "#3f5263",
                    outline: "none",
                    boxShadow: "none",
                  }}
                />
                {errors.name && (
                  <div className="invalid-feedback" style={{ color: "red" }}>
                    {errors.name}
                  </div>
                )}
              </div>
              <div className="mb-2 col-12 col-md-6">
                <label className="form-label text-light">Username</label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  className={`form-control text-primary ${
                    errors.username ? "is-invalid" : ""
                  }`}
                  placeholder="Enter username"
                  style={{
                    borderColor: "#3f5263",
                    outline: "none",
                    boxShadow: "none",
                  }}
                />
                {errors.username && (
                  <div className="invalid-feedback " style={{ color: "red" }}>
                    {errors.username}
                  </div>
                )}
              </div>
            </div>

            <div className="mb-2">
              <label className="form-label text-light">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`form-control  ${errors.email ? "is-invalid" : ""}`}
                placeholder="Enter email"
                style={{
                  borderColor: "#3f5263",
                  outline: "none",
                  boxShadow: "none",
                }}
              />
              {errors.email && (
                <div className="invalid-feedback " style={{ color: "red" }}>
                  {errors.email}
                </div>
              )}
            </div>

            <div className="mb-2 position-relative">
              <label className="form-label text-light">Password</label>

              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={`form-control pe-5 ${
                  errors.password ? "is-invalid" : ""
                }`}
                placeholder="Enter password"
                style={{
                  borderColor: "#3f5263",
                  outline: "none",
                  boxShadow: "none",
                }}
              />

              {/* Eye Icon */}
              <i
                className={` text-light bi ${
                  showPassword ? "bi-eye-slash" : "bi-eye"
                } position-absolute`}
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  top: "38px",
                  right: "12px",
                  cursor: "pointer",
                  color: "#aaa",
                }}
              ></i>

              {errors.password && (
                <div
                  className="invalid-feedback d-block"
                  style={{ color: "red" }}
                >
                  {errors.password}
                </div>
              )}
            </div>

            <div className="mb-3 text-start">
              <label className="form-label">Phone</label>

              <div style={{ position: "relative", width: "100%" }}>
                <img
                  src="https://flagcdn.com/et.svg"
                  alt="Ethiopia"
                  style={{
                    width: "24px",
                    height: "16px",
                    position: "absolute",
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />

                <span
                  style={{
                    position: "absolute",
                    left: "40px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "1rem",
                    color: "black",
                    userSelect: "none",
                  }}
                >
                  +251
                </span>

                <input
                  type="tel"
                  maxLength={9}
                  value={formData.phone.replace("+251", "")}
                  className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/\D/g, "");
                    setFormData((prev) => ({ ...prev, phone: `+251${raw}` }));
                    setErrors((prev) => ({ ...prev, phone: "" }));
                  }}
                  placeholder="911 234 567"
                  style={{
                    width: "100%",
                    height: "40px",
                    paddingLeft: "90px",
                    fontSize: "1rem",
                    border: "2px solid #3f5263",
                    borderRadius: "0.375rem",
                    outline: "none",
                  }}
                />
              </div>

              {errors.phone && (
                <div
                  className="invalid-feedback d-block mt-1"
                  style={{ color: "red" }}
                >
                  {errors.phone}
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-light text-info" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSave}>
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDeliveryPersonModal;
